<div class="main-content table-page table-page--compact captura-manual-page">
  <div class="container-fluid">
  <section class="table-page__hero">
    <div class="table-page__copy">
      <h1>Captura manual semanal</h1>
      <p>Agregue bloques manuales y revise si quedaron validados o pendientes de autorización.</p>
    </div>

    <div class="table-page__toolbar-actions captura-manual-page__hero-actions">
      <button type="button" mat-raised-button class="btn table-page__icon-btn table-page__icon-btn--secondary" (click)="volverAJornada()">
        <i class="material-icons">arrow_back</i>
        <span>Volver a mi jornada</span>
      </button>
      <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="cargarSemana()">
        <i class="material-icons">refresh</i>
        <span>Actualizar semana</span>
      </button>
    </div>
  </section>

  <section class="table-page__card">
    <div class="table-page__toolbar table-page__toolbar--filters">
      <div class="table-page__filters-grid">
        <div class="table-page__filter table-page__filter--narrow">
          <mat-form-field appearance="outline" class="table-page__field">
            <mat-label>Semana desde</mat-label>
            <input matInput [matDatepicker]="pickerInicio" [(ngModel)]="filtro.fecha_inicio" aria-label="Semana desde" />
            <mat-datepicker-toggle matSuffix [for]="pickerInicio"></mat-datepicker-toggle>
            <mat-datepicker #pickerInicio></mat-datepicker>
          </mat-form-field>
        </div>

        <div class="table-page__filter table-page__filter--narrow">
          <mat-form-field appearance="outline" class="table-page__field">
            <mat-label>Semana hasta</mat-label>
            <input matInput [matDatepicker]="pickerFin" [(ngModel)]="filtro.fecha_fin" aria-label="Semana hasta" />
            <mat-datepicker-toggle matSuffix [for]="pickerFin"></mat-datepicker-toggle>
            <mat-datepicker #pickerFin></mat-datepicker>
          </mat-form-field>
        </div>
      </div>

      <div class="table-page__toolbar-actions">
        <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="cargarSemana()">
          <i class="material-icons">date_range</i>
          <span>Consultar semana</span>
        </button>
      </div>
    </div>
  </section>

  <div class="row captura-manual-page__content-row">
    <div class="col-lg-5 col-md-12">
      <section class="table-page__card captura-manual-page__panel">
        <header class="captura-manual-page__encabezado">
          <h2>Nuevo bloque manual</h2>
          <p>Si el bloque cae fuera de jornada o rebasa el día, quedará pendiente.</p>
        </header>

        <div class="captura-manual-page__form-grid">
          <mat-form-field appearance="outline" class="table-page__field">
            <mat-label>Tarea</mat-label>
            <mat-select [(ngModel)]="registro.id">
              <mat-option *ngFor="let tarea of semana?.tareas || []" [value]="tarea.id">
                {{ tarea.nombre }}
              </mat-option>
            </mat-select>
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__field">
            <mat-label>Fecha</mat-label>
            <input matInput [matDatepicker]="pickerBloque" [(ngModel)]="fechaBloque" aria-label="Fecha" />
            <mat-datepicker-toggle matSuffix [for]="pickerBloque"></mat-datepicker-toggle>
            <mat-datepicker #pickerBloque></mat-datepicker>
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__field">
            <mat-label>Hora inicio</mat-label>
            <input matInput type="time" [(ngModel)]="horaInicio" aria-label="Hora inicio" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__field">
            <mat-label>Hora fin</mat-label>
            <input matInput type="time" [(ngModel)]="horaFin" aria-label="Hora fin" />
          </mat-form-field>

          <mat-form-field appearance="outline" class="table-page__field captura-manual-page__field--full">
            <mat-label>Motivo del ajuste</mat-label>
            <textarea matInput rows="4" maxlength="240" [(ngModel)]="registro.motivoRegistro" aria-label="Motivo del ajuste"></textarea>
          </mat-form-field>
        </div>

        <div class="table-page__toolbar-actions captura-manual-page__form-actions">
          <button type="button" mat-raised-button class="btn table-page__primary-btn" (click)="registrarBloque()" [disabled]="guardando">
            <i class="material-icons">save</i>
            <span>{{ guardando ? "Guardando..." : "Guardar bloque" }}</span>
          </button>
        </div>
      </section>
    </div>

    <div class="col-lg-7 col-md-12">
      <section class="table-page__card captura-manual-page__panel">
        <header class="captura-manual-page__encabezado">
          <h2>Bloques de la semana</h2>
          <p>Origen y estado de autorización de cada bloque.</p>
        </header>

        <div class="table-page__table-wrap">
          <table class="table-page__table" *ngIf="bloquesOrdenados.length > 0; else capturaManualEmptyState">
            <thead>
              <tr>
                <th>Fecha</th>
                <th>Tarea</th>
                <th>Bloque</th>
                <th>Tiempo</th>
                <th>Estatus</th>
                <th>Detalle</th>
              </tr>
            </thead>
            <tbody>
              <tr *ngFor="let bloque of bloquesOrdenados">
                <td>{{ bloque.inicio | date : "EEE dd/MM" }}</td>
                <td>
                  <div class="table-page__cell-stack">
                    <strong>{{ resolverNombreTarea(bloque.idTarea) }}</strong>
                    <span class="table-page__subtext">{{ bloque.motivoRegistro || "Sin motivo adicional" }}</span>
                  </div>
                </td>
                <td>{{ bloque.inicio | date : "HH:mm" }} - {{ bloque.fin | date : "HH:mm" }}</td>
                <td>
                  <div class="table-page__cell-stack">
                    <strong>{{ bloque.tiempoRegistradoStr || bloque.tiempoInvertidoStr }}</strong>
                    <span class="table-page__subtext" *ngIf="bloque.tiempoInvertidoStr && bloque.tiempoInvertidoStr !== '00:00:00'">Validado {{ bloque.tiempoInvertidoStr }}</span>
                  </div>
                </td>
                <td>
                  <span class="captura-manual-page__status-chip" [ngClass]="'is-' + estatusBloque(bloque).toLowerCase()">
                    {{ estatusBloque(bloque) }}
                  </span>
                </td>
                <td>{{ resumenBloque(bloque) }}</td>
              </tr>
            </tbody>
          </table>

          <ng-template #capturaManualEmptyState>
            <div class="table-page__empty">
              <i class="material-icons">history_toggle_off</i>
              <strong>No hay bloques en la semana consultada</strong>
              <span>Empiece por seleccionar una tarea y registrar el primer bloque manual.</span>
            </div>
          </ng-template>
        </div>
      </section>
    </div>
  </div>
  </div>
</div>
